export const MAIN_CLASS_NAME = 'avatar-picker';
export const POPOVER_CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__popover-content`;
export const POPOVER_GRID_CLASS_NAME = `${POPOVER_CONTENT_CLASS_NAME}__grid`;
export const POPOVER_GRID_ITEM_CLASS_NAME = `${POPOVER_GRID_CLASS_NAME}__item`;

export const DEFAULT_AVATAR_NAME = 'default';
